export const GROUPLIST_SEARCH = 'GROUPLIST_SEARCH';
export const GROUPLIST_PAGE = 'GROUPLIST_PAGE';
